import { lazyComponent } from "../../handlers/load.handler";

export const Inclusive = lazyComponent(() => import("./Inclusive/Inclusive"));
